import React from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { Flex } from "@nubeteck/components";
import { GradesDocumentContainer } from "../current-term-grades/current-term-grades.styled";
import { Spin } from "antd";
import { useGetScholarshipHistoryMutation } from "src/services";
import { FlexPDFButtonsStyled, SpinnerContainerStyled } from "src/pages/cart/cart.styled";
import { ButtonPrimaryStyled } from "src/components/custom/buttons/buttons.styled";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/legacy/build/pdf.worker.min.js`;

function ScholarshipHistory() {
  // const [carreraId, setCarreraId] = useState();
  // const { data: careers } = useGetCareersQuery("", { refetchOnMountOrArgChange: true });
  const [getReport, { data: report, isLoading: isLoadingReport }] =
    useGetScholarshipHistoryMutation();
  const [PDFPages, setPDFPages] = React.useState<number>(0);

  React.useEffect(() => {
    getReport();
    // getReport({ carreraId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDocLoadSuccess = ({ numPages }: { numPages: number }) => {
    setPDFPages(numPages);
  };

  const getPdfPages = () => {
    const pages: JSX.Element[] = [];
    for (let index = 1; index <= PDFPages; index++) {
      pages.push(
        <Page
          pageNumber={index}
          width={window.innerWidth / 1.4}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          renderMode="canvas"
        />,
      );
    }
    return pages;
  };

  return (
    <>
      <Flex style={{ gap: "15px", alignItems: "baseline", justifyContent: "space-between" }}>
        {/* <Form.Item label="Filtro por carrera">
          <Select
            value={carreraId}
            options={careers?.data?.map((c: any) => ({
              label: c.carreraNombre,
              value: c.carreraId,
            }))}
            onChange={(value) => {
              setCarreraId(value);
            }}
            placeholder="Seleccione una carrera"
          />
        </Form.Item> */}
        <FlexPDFButtonsStyled>
          <ButtonPrimaryStyled
            loading={isLoadingReport}
            type="link"
            href={`data:application/pdf;base64,${report}`}
            download="Reporte historial de becas.pdf"
          >
            Descargar PDF
          </ButtonPrimaryStyled>
        </FlexPDFButtonsStyled>
      </Flex>
      <GradesDocumentContainer>
        {isLoadingReport && (
          <SpinnerContainerStyled>
            <Spin spinning={isLoadingReport} size="large" />
          </SpinnerContainerStyled>
        )}
        <Document file={`data:application/pdf;base64,${report}`} onLoadSuccess={onDocLoadSuccess}>
          {getPdfPages()}
        </Document>
      </GradesDocumentContainer>
    </>
  );
}

export default ScholarshipHistory;
